import { VisitOutcome, VisitState } from '@/types/graphql';
import { isCanceledOutcome, isVisitUnscheduled } from '@/types/visit';
import {
    Check,
    Circle,
    CircleOutlined,
    Close,
    Remove,
    SvgIconComponent,
} from '@mui/icons-material';

export enum VisitStatusKind {
    Completed = 'completed',
    Missed = 'missed',
    Canceled = 'canceled',
    Scheduled = 'scheduled',
    Unscheduled = 'unscheduled',
}

export const getVisitStatusKind = (state: VisitState, outcome: VisitOutcome): VisitStatusKind => {
    if (outcome === VisitOutcome.COMPLETED) {
        return VisitStatusKind.Completed;
    }
    if (isCanceledOutcome(outcome)) {
        return VisitStatusKind.Canceled;
    }
    if (outcome !== VisitOutcome.NONE) {
        return VisitStatusKind.Missed;
    }
    if (isVisitUnscheduled(state)) {
        return VisitStatusKind.Unscheduled;
    }
    return VisitStatusKind.Scheduled;
};

export const visitStatusGlyph: Record<VisitStatusKind, SvgIconComponent> = {
    [VisitStatusKind.Completed]: Check,
    [VisitStatusKind.Missed]: Close,
    [VisitStatusKind.Canceled]: Remove,
    [VisitStatusKind.Scheduled]: Circle,
    [VisitStatusKind.Unscheduled]: CircleOutlined,
};

export const visitStatusLabel: Record<VisitStatusKind, string> = {
    [VisitStatusKind.Completed]: 'Completed',
    [VisitStatusKind.Missed]: 'Missed',
    [VisitStatusKind.Canceled]: 'Canceled',
    [VisitStatusKind.Scheduled]: 'Scheduled',
    [VisitStatusKind.Unscheduled]: 'Unscheduled',
};
